import { selectFoundPoiIds, selectFilters, searchPois, selectPoiById } from './poisSlice';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PoiList from './PoiList';
import Navbar from '../../app/Navbar';
import { useHistory } from 'react-router';
import { getPosition } from '../../api/mobile';



const SearchPoiPage = ({ match }) => {
    const {category} = match.params;
    
    const [categoryStatus, setCategoryStatus] = useState('idle');
    const poiIds = useSelector(selectFoundPoiIds);
    const poiStatus = useSelector(state => state.pois.foundPois.status);
    const error = useSelector((state) => state.pois.foundPois.error);
    const history = useHistory();
    const goBack = (event) => {
        event.preventDefault();
        history.push('/home');
    };
    const currentFilters = useSelector(selectFilters);
    const dispatch = useDispatch();
    const loadMore = () => {
        let offset = (typeof currentFilters.offset === 'undefined') ? 0 : currentFilters.offset;
        offset += currentFilters.limit;
        dispatch(searchPois({
            ...currentFilters,
            offset: offset
        }));
    };
    useEffect(async () => {
        if (category && categoryStatus === 'idle') {
            let params = {
                limit: 10
            };
            let position = await getPosition();
            params.lat = position.lat;
            params.lng = position.lng;
            switch(category) {
                case 'campsites':
                    params.camp = true;
                    break;
                case 'service-areas':
                    params.serv = true;
                    break;
                case 'parking-areas':
                    params.sosta = true;
                    break;
                case 'club-benefits':
                    params.conv = true;
                    break;
                case 'attractions':
                    params.attr = true;
            }
            dispatch(searchPois(params));
            setCategoryStatus(poiStatus);
        }
    }, [category, categoryStatus, dispatch]);

    return <div id="search_poi_page">
        <PoiList poiIds={poiIds} status={poiStatus} error={error} onGoBack={goBack} onLoadMore={loadMore} selectById={selectPoiById}/>
        <Navbar/>
    </div>
};

export default SearchPoiPage;